{
  "apiKey": "AIzaSyAZY52rMUMCXbTZ4DOS0xTafZcfyUDTQNM",
  "authDomain": "broox-studio-analytics-exp.firebaseapp.com",
  "projectId": "broox-studio-analytics-exp",
  "storageBucket": "broox-studio-analytics-exp.firebasestorage.app",
  "messagingSenderId": "889442512334",
  "appId": "1:889442512334:web:9355213befcfd15bfc0f9f"
}